import { createGlobalStyle} from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.colors.body};
    font-family: ${({ theme }) => theme.font};
  }

  a {
    color: ${({ theme }) => theme.colors.link.text} !important;
    cursor: pointer;
  }

  label.link {
    color: ${({ theme }) => theme.colors.link.text} !important;
    cursor: pointer;
  }

  label.text-secondary {
    color: ${props => props?.extraStyle?.colorFont ? `${props?.extraStyle?.colorFont}!important` : "inherit"};
    font-size: ${props => props?.extraStyle?.fontSize ? `${props?.extraStyle?.fontSize}px!important` : "inherit"};
  }

  button {
    border: 0;
    display: inline-block;
    padding: 12px 24px;
    font-size: 14px;
    border-radius: 4px;
    margin-top: 5px;
    cursor: pointer;
    background-color: #1064EA;
    color: #FFFFFF;
    font-family: ${({ theme }) => theme.font};
  }

  button.btn1 {
    background-color: ${({ theme }) => theme.colors.button.background};
    color: ${({ theme }) => theme.colors.button.text};
    border-color: ${({ theme }) => theme.colors.button.background};
  }

  button.btn1:hover,
  button.btn1:focus,
  button.btn1:active {
      background-color: ${({ theme }) => theme.colors.button.hover};
  }

  div.card-header {
    background-color: ${({ theme }) => theme.colors.cardhead.background} !important;
  }

  div.card-header .text{
    color: ${({ theme }) => theme.colors.cardhead.text};
  }

  ul li span {
    color: ${({ theme }) => theme.colors.li.text};
  }

  ul li.no-active-hour span {
    color: ${({ theme }) => theme.colors.li.opacity};
  }

  .text-style{
    color: ${({ theme }) => theme.colors.li.text} !important;
  }

  .css-1n7v3ny-option{
    color: #444!important;
  }
`;